import React, { useEffect, useState } from "react";
import API from "../../services/api";

function ComparisonReport(props) {
  const { month, year, newReports } = props;
  const [previousMonthData, setPreviousMonthData] = useState([]);
  const [presentMonthData, setPresentMonthData] = useState([]);
  const [currentDay, setCurrentDay] = useState(31);
  const [differenceTotal, setDifferenceTotal] = useState(0);
  const [previousTotal, setPreviousTotal] = useState(0);
  const [presentTotal, setPresenTotal] = useState(0);

  function getDaysInMonth(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    return lastDayOfMonth;
  }
  function getPreviousMonth(currentYear, currentMonth) {
    const currentDate = new Date(currentYear, currentMonth - 1, 1); // Month is zero-based

    // Set the date to the last day of the previous month
    currentDate.setDate(0);

    // Get the year and month of the previous month
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1

    return { year, month };
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const startDate = new Date(year, month - 1, 1); // Start of the month
    const endDate = new Date(year, month, 0); // End of the month (0th day of the next month)

    // Convert to timestamps (in seconds)
    const startTimestamp = Math.floor(startDate.getTime() / 1000);
    const endTimestamp = Math.floor(endDate.getTime() / 1000);

    return { startTimestamp, endTimestamp };
  }
  const previousMonth = getPreviousMonth(year, month);
  function getMonthName(monthNumber) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Ensure the month number is within a valid range
    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    } else {
      return "Invalid month number";
    }
  }

  const fetchData = async () => {
    try {
      let res = await API({
        url: "/reports/comparison-reports",
        method: "POST",
        responseType: "json",
        data: {
          previous: getStartAndEndOfMonthTimestamps(
            previousMonth.year,
            previousMonth.month
          ),
          present: getStartAndEndOfMonthTimestamps(year, month),
          newReport:newReports
        },
      });
      if (res.code === 200) {
        setPreviousMonthData(res?.data?.previousMonthData);
        setPresentMonthData(res?.data?.presentMonthData);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleCurrentDay = () => {
    setCurrentDay(getDaysInMonth(year, month - 1));
  };

  const fetchSpent = (month, year, index, from = "present") => {
      let { startTimestamp } = getStartAndEndOfMonthTimestamps(year, month);
      startTimestamp = startTimestamp + index * 86400;
      if (from === "previous") {
        for (let i = 0; i < previousMonthData.length; i++) {
          if (previousMonthData[i].date === startTimestamp) {
            return previousMonthData[i].totalSpent || 0;
          }
        }
        return 0;
      } else {
        for (let i = 0; i < presentMonthData.length; i++) {
          if (presentMonthData[i].date === startTimestamp) {
            return presentMonthData[i].totalSpent || 0;
          }
        }
        return 0;
      }
  };

  const calaculateDifference = (
    thisMonth,
    thisYear,
    prevMonth,
    prevYear,
    index,
    from = "difference"
  ) => {
    const previousSpent = fetchSpent(prevMonth, prevYear, index, "previous");
    const presentSpent = fetchSpent(thisMonth, thisYear, index);
    if (from === "class") {
      return presentSpent > previousSpent ? false : true;
    } else {
      return presentSpent - previousSpent;
    }
  };

  const calculateTotals = () => {
    let sumPrevious = 0;
    let sumPresent = 0;
    for (let i = 0; i < previousMonthData.length; i++) {
      sumPrevious += previousMonthData[i].totalSpent;
    }
    setPreviousTotal(sumPrevious);
    for (let i = 0; i < presentMonthData.length; i++) {
      sumPresent += presentMonthData[i].totalSpent;
    }
    setPresenTotal(sumPresent);

    let difference = 0;
    for (let i = 0; i < currentDay; i++) {
      difference += calaculateDifference(
        month,
        year,
        previousMonth.month,
        previousMonth.year,
        i
      );
    }
    setDifferenceTotal(difference);
  };

  useEffect(() => {
    fetchData();
    handleCurrentDay();
  }, [year, month, newReports]);

  useEffect(() => {
    calculateTotals();
  }, [presentMonthData, previousMonthData]);

  return (
    <div className="report-image">
      <h3 id="comparison-h4">Month Wise Revenue Comparison</h3>
      <div className="overflow-x-auto">
        <table
          className="table table-bordered report-table"
          id="comparison-table"
        >
          <thead>
            <tr>
              <th>Day</th>
              <th>{getMonthName(previousMonth.month)}</th>
              <th>{getMonthName(month)}</th>
              <th>Difference</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 31 }, (_, index) => (
              <tr key={index}>
                <td>{`${index + 1}`}</td>
                <td>
                  {parseFloat(fetchSpent(
                    previousMonth.month,
                    previousMonth.year,
                    index,
                    "previous"
                  )).toFixed(2)}
                </td>
                <td>{parseFloat(fetchSpent(month, year, index)).toFixed(2)}</td>
                <td
                  className={
                    calaculateDifference(
                      month,
                      year,
                      previousMonth.month,
                      previousMonth.year,
                      index,
                      "class"
                    )
                      ? "negative-difference"
                      : "positive-difference"
                  }
                >
                  {parseFloat(
                    calaculateDifference(
                      month,
                      year,
                      previousMonth.month,
                      previousMonth.year,
                      index
                    )
                  ).toFixed(2)}
                </td>
              </tr>
            ))}
            <tr>
              <td className="total-color-comparison">Grand Total</td>
              <td className="total-color-comparison">
                {parseFloat(previousTotal).toFixed(2)}
              </td>
              <td className="total-color-comparison">
                {parseFloat(presentTotal).toFixed(2)}
              </td>
              <td
                className={
                  differenceTotal > 0
                    ? "positive-difference"
                    : "negative-difference"
                }
              >
                {parseFloat(differenceTotal).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ComparisonReport;
